import * as React from 'react';

export class SeekerTrack extends React.Component {
  public render() {
    return <div></div>;
  }
}
